'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelGroupedBase = exports.ModelUngroupedBase = exports.ModelBase = exports.DefaultModelCollection = exports.ModelCollectionBase = exports.ApiSave = exports.MetaCollection = exports.apiMetaUnloaded = exports.ApiMeta = exports.ApiFilterData = exports.ApiGroupData = exports.ApiDataSource = exports.ApiAuthentication = exports.ApiRoot = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _desc2, _value2, _class2, _desc3, _value3, _class3, _desc4, _value4, _class4, _desc5, _value5, _class5;

var _immutable = require('immutable');

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

var _constants = require('./constants');

var _exceptions = require('./exceptions');

var _schema = require('./schema');

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*
 * Wrapper for the root of all data handled by the API.
 */
var ApiRoot = exports.ApiRoot = (0, _immutable.Record)({
  authentication: undefined,
  data: undefined
});

/*
 * Wrapper for API authentication data
 */
var ApiAuthentication = exports.ApiAuthentication = (0, _immutable.Record)({
  authenticated: false,
  loading: false,
  loadingError: null,
  payload: undefined
});

/*
 * Wrapper for API data and associated model
 */
var ApiDataSource = exports.ApiDataSource = (0, _immutable.Record)({
  dataSource: undefined,
  dataSourceType: undefined, // Ya, this could be a shorter name, but `type` is hard to search for
  groups: undefined
});

/*
 * Wrapper for API state of object data
 */
var ApiGroupData = exports.ApiGroupData = (0, _immutable.Record)({
  filters: undefined,
  model: undefined,
  modelName: undefined,
  loading: false,
  loadingUnauthorized: false,
  loadingError: null
});

/*
 * Wrapper for API state of object data
 */
var ApiFilterData = exports.ApiFilterData = (0, _immutable.Record)({
  alias: undefined,
  query: undefined,
  sort: undefined,
  limit: undefined,
  only: undefined,
  payload: undefined,
  meta: undefined,
  subscribers: undefined
});

/*
 * Wrapper for API state of object meta data
 */
var ApiMetaRecord = (0, _immutable.Record)({
  authorization: undefined,
  hasInitialData: false,
  itemCount: 0,
  loading: false,
  loadingUnauthorized: false,
  loadingError: null,
  model: undefined,
  modelName: undefined,
  needsUpdate: false,
  lastInsertKey: 0,
  etag: undefined,
  lastModified: undefined,
  lruSequence: undefined, // (L)east (R)ecently (U)sed cache integer.
  lastRequestTimestamp: undefined
});

var ApiMeta = exports.ApiMeta = (_class = function (_ApiMetaRecord) {
  _inherits(ApiMeta, _ApiMetaRecord);

  function ApiMeta() {
    _classCallCheck(this, ApiMeta);

    return _possibleConstructorReturn(this, (ApiMeta.__proto__ || Object.getPrototypeOf(ApiMeta)).apply(this, arguments));
  }

  _createClass(ApiMeta, [{
    key: 'hasDataOrError',
    get: function get() {
      return this.hasInitialData === true || this.loadingError !== null;
    }
  }]);

  return ApiMeta;
}(ApiMetaRecord), (_applyDecoratedDescriptor(_class.prototype, 'hasDataOrError', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'hasDataOrError'), _class.prototype)), _class);
var apiMetaUnloaded = exports.apiMetaUnloaded = new ApiMeta();

var ApiMetaCollectionRecord = (0, _immutable.Record)({
  metas: undefined
});

var MetaCollection = exports.MetaCollection = function (_ApiMetaCollectionRec) {
  _inherits(MetaCollection, _ApiMetaCollectionRec);

  function MetaCollection() {
    _classCallCheck(this, MetaCollection);

    return _possibleConstructorReturn(this, (MetaCollection.__proto__ || Object.getPrototypeOf(MetaCollection)).apply(this, arguments));
  }

  _createClass(MetaCollection, [{
    key: 'createSubCollection',
    value: function createSubCollection(metas) {
      if (metas === this.metas) {
        return this;
      }

      var cls = this.constructor;
      return new cls({ metas: metas });
    }
  }, {
    key: 'filterMetas',
    value: function filterMetas(predicate) {
      var newItems = this.metas.filter(predicate);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'filterNotMetas',
    value: function filterNotMetas(predicate) {
      var newItems = this.metas.filterNot(predicate);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'getMetaKeys',
    value: function getMetaKeys() {
      return this.metas.keySeq();
    }
  }, {
    key: 'getMetas',
    value: function getMetas() {
      return this.metas.valueSeq();
    }
  }, {
    key: 'getMeta',
    value: function getMeta(metaKey) {
      return this.metas.get(metaKey);
    }
  }, {
    key: 'firstMeta',
    value: function firstMeta() {
      return this.metas.first();
    }
  }, {
    key: 'lastMeta',
    value: function lastMeta() {
      return this.metas.last();
    }
  }, {
    key: 'hasMeta',
    value: function hasMeta(metaKey) {
      return this.metas.has(metaKey);
    }
  }, {
    key: 'some',
    value: function some() {
      var _metas;

      return (_metas = this.metas).some.apply(_metas, arguments);
    }
  }, {
    key: 'map',
    value: function map() {
      var _metas2;

      return (_metas2 = this.metas).map.apply(_metas2, arguments);
    }
  }, {
    key: 'forEach',
    value: function forEach() {
      var _metas3;

      return (_metas3 = this.metas).forEach.apply(_metas3, arguments);
    }
  }, {
    key: 'countMetas',
    value: function countMetas() {
      var _metas4;

      return (_metas4 = this.metas).count.apply(_metas4, arguments);
    }
  }, {
    key: 'countMetasBy',
    value: function countMetasBy() {
      var _metas5;

      return (_metas5 = this.metas).countBy.apply(_metas5, arguments);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.metas.isEmpty();
    }
  }, {
    key: 'hasInitialData',
    get: function get() {
      return this.metas.valueSeq().every(function (v) {
        return v.hasInitialData;
      });
    }
  }, {
    key: 'hasSomeData',
    get: function get() {
      return this.metas.valueSeq().some(function (v) {
        return v.hasInitialData;
      });
    }
  }, {
    key: 'hasDataOrError',
    get: function get() {
      return this.metas.valueSeq().every(function (v) {
        return v.hasDataOrError;
      });
    }
  }, {
    key: 'hasSomeDataOrError',
    get: function get() {
      return this.metas.valueSeq().some(function (v) {
        return v.hasDataOrError;
      });
    }
  }, {
    key: 'loading',
    get: function get() {
      return this.metas.valueSeq().some(function (v) {
        return v.loading;
      });
    }
  }, {
    key: 'loadingUnauthorized',
    get: function get() {
      return this.metas.valueSeq().some(function (v) {
        return v.loadingUnauthorized;
      });
    }
  }, {
    key: 'loadingError',
    get: function get() {
      var error = this.metas.valueSeq().filter(function (v) {
        return v.loadingError;
      }).first();
      return error && error.loadingError ? error.loadingError : undefined;
    }
  }, {
    key: 'needsUpdate',
    get: function get() {
      return this.metas.valueSeq().some(function (v) {
        return v.needsUpdate;
      });
    }
  }, {
    key: 'lastModified',
    get: function get() {
      var metas = this.metas.valueSeq();
      if (!(metas.size > 0)) {
        return undefined;
      }

      return metas.reduce(function (max, v) {
        return max === undefined || v.lastModified > max ? v.lastModified : max;
      }, metas.get(0).lastModified);
    }
  }, {
    key: 'lastRequestTimestamp',
    get: function get() {
      var metas = this.metas.valueSeq();
      return metas.reduce(function (max, v) {
        return v.lastRequestTimestamp > max ? v.lastRequestTimestamp : max;
      }, metas.get(0));
    }
  }, {
    key: 'models',
    get: function get() {
      return (0, _immutable.Set)(this.metas.valueSeq().map(function (v) {
        return v.model;
      }));
    }
  }, {
    key: 'modelNames',
    get: function get() {
      return (0, _immutable.Set)(this.metas.valueSeq().map(function (v) {
        return v.modelName;
      }));
    }
  }]);

  return MetaCollection;
}(ApiMetaCollectionRecord);

/*
 * Wrapper for a request to save API data to via a writing callback
 */


var ApiSave = exports.ApiSave = (0, _immutable.Record)({
  id: undefined,
  api_id: undefined,
  action: undefined,
  changes: undefined
});

// Setup a default set of relationshisp with no relationship keys
var DefaultRelationshipSchema = (0, _schema.Schema)();

/*
 * Base attributes for all model collections
 */
var ModelCollectionBaseRecord = (0, _immutable.Record)({
  items: undefined
});

/*
 * Base attributes for all model items
 *
 * NOTE: All items being within an underscore to reduce collisions with the actual model schema attributes
 */
var ModelBaseRecord = (0, _immutable.Record)({
  _combined: undefined, // Combined server and draft
  _lastValid: undefined, // Last valid combined state
  _invalid: undefined, // Map of potential errors.  Leaves are List()s

  _draft: undefined,
  _draftCreation: false,
  _draftRemoval: false,

  _draftRelationships: undefined, // Map of related data to include a POST when inserting new, related data.
  _draftRelationshipsInvalid: undefined, // Map of invalid relationships data

  _interfaceID: undefined, // ID of the model item within the user interface (once set, cannot be changed)
  _storeID: undefined, // ID of the model item within the store and within the data source (updated on save)

  _order: undefined, // Occurence order for the record as it came in from the server

  _server: undefined,
  _serverRemoved: false,
  _serverTemporary: false, // True if this server item was added as a back-fill before signalling updates the _server

  _saving: false,
  _saveError: undefined
});

/*
 * Base class for all model collections.  This class keeps track of the reducer that produced it and also provides
 * the ability to create sub collections based on the same class, but with different contents.
 */
var ModelCollectionBase = exports.ModelCollectionBase = (_class2 = function (_ModelCollectionBaseR) {
  _inherits(ModelCollectionBase, _ModelCollectionBaseR);

  function ModelCollectionBase() {
    _classCallCheck(this, ModelCollectionBase);

    return _possibleConstructorReturn(this, (ModelCollectionBase.__proto__ || Object.getPrototypeOf(ModelCollectionBase)).apply(this, arguments));
  }

  _createClass(ModelCollectionBase, [{
    key: 'bindReducer',


    /*
     * Proxy a few key underlying map methods, memoize them, and return the result as a new collection if different.
     *
     * filterItems and filterNotItems will return a new collection sub-set (memoized by predicate) of this
     *   collection (if it is different).
     * getItem will return an item from the map.
     * All other methods will just call the identical method on the underlying items.
     */
    value: function bindReducer(reducer, dispatch, dataSource, group, filterName) {
      this._reducer = reducer;
      this._dispatch = dispatch;
      this._dataSource = dataSource;
      this._group = group;
      this._filterName = filterName;
    }
  }, {
    key: 'deferredAction',
    value: function deferredAction(name, args, creatorCb) {
      // Check (and maybe build) the action creator function cache
      var cache = this._deferredActions;
      if (cache === undefined) {
        cache = (0, _immutable.Map)();
      }

      // Get (and maybe create) the action creator from the cache
      var creator = cache.getIn([name, args]);
      if (creator === undefined) {
        creator = creatorCb(this.boundMeta);
        cache = cache.setIn([name, args], creator);
        this._deferredActions = cache;
      }

      return creator;
    }
  }, {
    key: 'createSubCollection',
    value: function createSubCollection(items) {
      if (items === this.items) {
        return this;
      }

      var cls = this.constructor;
      var newCollection = new cls({ items: items });
      if (this.isReducerBound) {
        newCollection.bindReducer(this._reducer, this._dispatch, this._dataSource, this._group, this._filterName);
      }
      return newCollection;
    }
  }, {
    key: 'filterItems',
    value: function filterItems(predicate) {
      var newItems = this.items.filter(predicate);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'filterNotItems',
    value: function filterNotItems(predicate) {
      var newItems = this.items.filterNot(predicate);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'getItemKeys',
    value: function getItemKeys() {
      return this.items.keySeq();
    }
  }, {
    key: 'getItemValues',
    value: function getItemValues(field) {
      return this.mapForUI(function (item) {
        return item[field];
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      return this.items.get(key);
    }
  }, {
    key: 'getItemWithInterfaceID',
    value: function getItemWithInterfaceID(interfaceID) {
      return this.filterItems(function (value) {
        return value._interfaceID === interfaceID;
      }).firstItem();
    }
  }, {
    key: 'firstItem',
    value: function firstItem() {
      return this.items.first();
    }
  }, {
    key: 'lastItem',
    value: function lastItem() {
      return this.items.last();
    }
  }, {
    key: 'hasItem',
    value: function hasItem(key) {
      return this.items.has(key);
    }
  }, {
    key: 'includesItem',
    value: function includesItem(key) {
      return this.items.includes(key);
    }
  }, {
    key: 'some',
    value: function some() {
      var _items;

      return (_items = this.items).some.apply(_items, arguments);
    }
  }, {
    key: 'groupByItems',
    value: function groupByItems() {
      var _items2,
          _this4 = this;

      var groupedItems = (_items2 = this.items).groupBy.apply(_items2, arguments);
      var groupedCollections = (0, _immutable.Map)().withMutations(function (map) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = groupedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2),
                group = _step$value[0],
                items = _step$value[1];

            map.set(group, _this4.createSubCollection(items));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return map;
      });
      return groupedCollections;
    }
  }, {
    key: 'map',
    value: function map() {
      var _items3;

      return (_items3 = this.items).map.apply(_items3, arguments);
    }
  }, {
    key: 'reduce',
    value: function reduce() {
      var _items4;

      return (_items4 = this.items).reduce.apply(_items4, arguments);
    }
  }, {
    key: 'mapForUI',
    value: function mapForUI(mapper) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$context = options.context,
          context = _options$context === undefined ? undefined : _options$context,
          _options$sortSelector = options.sortSelector,
          sortSelector = _options$sortSelector === undefined ? undefined : _options$sortSelector;

      return this.sortWithSelector(sortSelector).map(mapper, context).toList();
    }
  }, {
    key: 'sort',
    value: function sort() {
      var _items5;

      var newItems = (_items5 = this.items).sort.apply(_items5, arguments);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'sortBy',
    value: function sortBy() {
      var _items6;

      var newItems = (_items6 = this.items).sortBy.apply(_items6, arguments);
      return this.createSubCollection(newItems);
    }
  }, {
    key: 'sortWithSelector',
    value: function sortWithSelector() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (selector === undefined) {
        selector = this.defaultSortSelector;
      }
      return this.sort((0, _amsLoaderUtils.sortWithSelector)(selector));
    }
  }, {
    key: 'forEach',
    value: function forEach() {
      var _items7;

      return (_items7 = this.items).forEach.apply(_items7, arguments);
    }
  }, {
    key: 'countItems',
    value: function countItems() {
      var _items8;

      return (_items8 = this.items).count.apply(_items8, arguments);
    }
  }, {
    key: 'countItemsBy',
    value: function countItemsBy() {
      var _items9;

      return (_items9 = this.items).countBy.apply(_items9, arguments);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.items.isEmpty();
    }

    /*
     * Get only newly created items
     */

  }, {
    key: 'defaultSortSelector',
    value: function defaultSortSelector(item) {
      return this.constructor.defaultSortSelector(item);
    }

    /*
     * Return True if any item in the collection has drafted changes.
     */

  }, {
    key: 'hasDraftedChanges',
    value: function hasDraftedChanges(options) {
      var hasChanges = false;
      this.items.some(function (item) {
        if (item.hasDraftedChanges(options)) {
          hasChanges = true;
          return true;
        }
        return false;
      });
      return hasChanges;
    }

    /*
     * Return True if all of the items in the collection are valid
     */

  }, {
    key: 'isValid',
    value: function isValid(keys) {
      var isValid = true;
      this.items.some(function (item) {
        if (!item.isValid(keys)) {
          isValid = false;
          return true;
        }
        return false;
      });
      return isValid;
    }

    /*
     * Return True if any of the items in the collection are saving
     */

  }, {
    key: 'mutateItem',


    /*
     * Mutate an item in the collection with a given mutator function (compatible with Immutable.js withMutations)
     */
    value: function mutateItem(ids, mutator) {
      // If `ids` is just plain old data then it means it's a just a single ID.
      if (typeof ids === 'number' || typeof ids === 'string') {
        ids = (0, _immutable.Set)([ids]);
      }

      return this.withMutations(function (collection) {
        var items = collection.get('items');

        ids.forEach(function (id) {
          if (items.has(id)) {
            var item = items.get(id);
            var newItem = item.withMutations(mutator);

            // Account for case when the item is fully reset and it is a new record.
            var deleted = newItem === undefined || newItem._draftCreation && (newItem._draft === undefined || newItem._draftRemoval);
            if (deleted) {
              items = items.delete(id);
            } else {
              items = items.set(id, newItem);
            }
          }
        });
        collection.set('items', items);
        return collection;
      });
    }

    /*
     * Get all changes for this collection.
     */

  }, {
    key: 'saveItems',
    value: function saveItems(ids, keys) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$withAdded = options.withAdded,
          withAdded = _options$withAdded === undefined ? true : _options$withAdded;

      // If `ids` is just plain old data then it means it's a just a single ID.

      if (typeof ids === 'number' || typeof ids === 'string') {
        ids = (0, _immutable.Set)([ids]);
      }

      // An iterable of IDs
      var items = void 0;
      if (withAdded) {
        items = this.items.filter(function (item, id) {
          return item._draftCreation || ids.has(id);
        });
      } else {
        items = this.items.filter(function (item, id) {
          return ids.has(id);
        });
      }

      // Return changes for entire collection
      var saveItems = [];
      items.forEach(function (item, id) {
        if (item._saving === false) {
          if (item._draftRemoval) {
            saveItems.push(new ApiSave({
              id: id,
              api_id: item.uniqueKey !== undefined ? item.uniqueKey : null,
              action: item.draftAction,
              changes: undefined
            }));
          } else {
            var changes = item.draftedChanges(keys);
            if (!changes.isEmpty()) {
              saveItems.push(new ApiSave({
                id: id,
                api_id: item.uniqueKey !== undefined ? item.uniqueKey : null,
                action: item.draftAction,
                changes: changes
              }));
            }
          }
        }
      });

      return (0, _immutable.List)(saveItems);
    }
  }, {
    key: 'isReducerBound',
    get: function get() {
      return this._reducer !== undefined;
    }
  }, {
    key: 'boundMeta',
    get: function get() {
      return {
        reducer: this._reducer,
        dispatch: this._dispatch,
        dataSource: this._dataSource,
        filterName: this._filterName,
        group: this._group
      };
    }
  }, {
    key: 'created',
    get: function get() {
      return this.filterItems(this.constructor.createdItemsPredicate);
    }

    /*
     * Get only newly created items
     */

  }, {
    key: 'createdAndStable',
    get: function get() {
      return this.filterItems(this.constructor.createdAndStableItemsPredicate);
    }

    /*
     * Get items that have been created or removed, but not stable items
     */

  }, {
    key: 'createdAndRemoved',
    get: function get() {
      return this.filterItems(this.constructor.createdAndRemovedItemsPredicate);
    }

    /*
     * Get items that have been created and saved
     */

  }, {
    key: 'createdAndSaved',
    get: function get() {
      return this.filterItems(this.constructor.createdAndSavedItemsPredicate);
    }

    /*
     * Get only stable items
     */

  }, {
    key: 'stable',
    get: function get() {
      return this.filterItems(this.constructor.stableItemsPredicate);
    }

    /*
     * Get items that are either stable or have been removed
     */

  }, {
    key: 'stableAndRemoved',
    get: function get() {
      return this.filterItems(this.constructor.stableAndRemovedItemsPredicate);
    }
  }, {
    key: 'isItem',
    get: function get() {
      var cls = this.constructor;
      return cls.isItem;
    }
  }, {
    key: 'isCollection',
    get: function get() {
      var cls = this.constructor;
      return cls.isCollection;
    }

    /*
     * Default sort selector to use for an item in this collection (override if a different key is needed.
     */

  }, {
    key: 'reducerIDs',
    get: function get() {
      return this.items.map(function (item) {
        return item._storeID;
      }).toSet();
    }

    /*
     * Convenience function for getting the sort selector from an instance without referencing the constructor.
     */

  }, {
    key: 'saving',
    get: function get() {
      var isSaving = false;
      this.items.some(function (item) {
        if (item.saving) {
          isSaving = true;
          return true;
        }
        return false;
      });
      return isSaving;
    }
  }], [{
    key: 'createdItemsPredicate',
    value: function createdItemsPredicate(value) {
      return value !== undefined && value._draftCreation === true && value._draftRemoval === false;
    }
  }, {
    key: 'createdAndStableItemsPredicate',
    value: function createdAndStableItemsPredicate(value) {
      return value !== undefined && value._draftRemoval === false;
    }
  }, {
    key: 'createdAndRemovedItemsPredicate',
    value: function createdAndRemovedItemsPredicate(value) {
      return value !== undefined && (value._draftCreation === true || value._draftRemoval === true);
    }
  }, {
    key: 'createdAndSavedItemsPredicate',
    value: function createdAndSavedItemsPredicate(value) {
      return value !== undefined && value._draftCreation === false && value._draftRemoval === false && value._interfaceID !== value._storeID;
    }
  }, {
    key: 'stableItemsPredicate',
    value: function stableItemsPredicate(value) {
      return value !== undefined && value._draftCreation === false && value._draftRemoval === false;
    }
  }, {
    key: 'stableAndRemovedItemsPredicate',
    value: function stableAndRemovedItemsPredicate(value) {
      return value !== undefined && value._draftCreation === false;
    }
  }, {
    key: 'defaultSortSelector',
    value: function defaultSortSelector(item) {
      return item._order;
    }

    /*
     * List of fixed IDs in this
     */

  }, {
    key: 'isItem',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCollection',
    get: function get() {
      return true;
    }
  }]);

  return ModelCollectionBase;
}(ModelCollectionBaseRecord), (_applyDecoratedDescriptor(_class2.prototype, 'reducerIDs', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class2.prototype, 'reducerIDs'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'defaultSortSelector', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, 'defaultSortSelector'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasDraftedChanges', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class2.prototype, 'hasDraftedChanges'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isValid', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class2.prototype, 'isValid'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'saving', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class2.prototype, 'saving'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'saveItems', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class2.prototype, 'saveItems'), _class2.prototype)), _class2);

/*
 * Default Model Collection used on all Models
 */

var DefaultModelCollection = exports.DefaultModelCollection = function (_ModelCollectionBase) {
  _inherits(DefaultModelCollection, _ModelCollectionBase);

  function DefaultModelCollection() {
    _classCallCheck(this, DefaultModelCollection);

    return _possibleConstructorReturn(this, (DefaultModelCollection.__proto__ || Object.getPrototypeOf(DefaultModelCollection)).apply(this, arguments));
  }

  return DefaultModelCollection;
}(ModelCollectionBase);

/*
 * Base class for all Model's used with the API reducer.  If you need methods that operate on an entire collection,
 * then the best way is to define them as static methods on the model.
 */


var ModelBase = exports.ModelBase = (_class3 = function (_ModelBaseRecord) {
  _inherits(ModelBase, _ModelBaseRecord);

  function ModelBase() {
    _classCallCheck(this, ModelBase);

    return _possibleConstructorReturn(this, (ModelBase.__proto__ || Object.getPrototypeOf(ModelBase)).apply(this, arguments));
  }

  _createClass(ModelBase, [{
    key: 'bindReducer',
    value: function bindReducer(reducer, dispatch, dataSource, group, filterName) {
      this._reducer = reducer;
      this._dispatch = dispatch;
      this._dataSource = dataSource;
      this._group = group;
      this._filterName = filterName;
    }
  }, {
    key: 'deferredAction',
    value: function deferredAction(name, args, creatorCb) {
      // Check (and maybe build) the action creator function cache
      var cache = this._deferredActions;
      if (cache === undefined) {
        cache = (0, _immutable.Map)();
      }

      // Get (and maybe create) the action creator from the cache
      var creator = cache.getIn([name, args]);
      if (creator === undefined) {
        creator = creatorCb(this.boundMeta);
        cache = cache.setIn([name, args], creator);
        this._deferredActions = cache;
      }

      return creator;
    }
  }, {
    key: 'serverValue',
    value: function serverValue(key) {
      var default_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (this._server === undefined) {
        return default_;
      }
      return this._server.get(key);
    }

    /*
     * Get the server value for a given key or undefined if there is no server version or
     * the server value matches the draft value.
     */

  }, {
    key: 'serverDiffValue',
    value: function serverDiffValue(key) {
      if (this._server === undefined) {
        return undefined;
      }
      if (this._draft === undefined) {
        return undefined;
      }

      var server = this._server.get(key);
      var draft = this._draft.get(key);

      if (server === draft) {
        return undefined;
      }
      return server;
    }

    /*
     * Check if this item has any drafted changes (optionally including if this is a removed or created item)
     *
     * By default, sub-classes get no drafted changes.
     */

  }, {
    key: 'hasDraftedChanges',
    value: function hasDraftedChanges(options) {
      throw new _exceptions.ModelMutateNotSupported('Can\'t check for drafted changes on a non-draftable model.');
    }

    /*
     * Get all draft changes in this object (excludes undefined entries in the Record)
     */

  }, {
    key: 'draftedChanges',
    value: function draftedChanges() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SAVE_ALL;

      if (keys !== undefined && keys !== _constants.SAVE_ALL) {
        throw new _exceptions.ModelMutateNotSupported('Can\'t draft changes for ' + keys + ' on a non-draftable model.');
      } else {
        throw new _exceptions.ModelMutateNotSupported('Can\'t draft changes for all keys on a non-draftable model.');
      }
    }

    /*
     * Get first invalid error for a given set of keys
     */

  }, {
    key: 'firstInvalidMeta',
    value: function firstInvalidMeta() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (keys !== undefined) {
        throw new _exceptions.ModelMutateNotSupported('Can\'t check validity for ' + keys + ' on a non-draftable model.');
      } else {
        throw new _exceptions.ModelMutateNotSupported('Can\'t check validity for all keys on a non-draftable model.');
      }
    }

    /*
     * Return true if the model is valid.  Optionally filter by the given set of keys.
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (keys !== undefined) {
        throw new _exceptions.ModelMutateNotSupported('Can\'t check validity for ' + keys + ' on a non-draftable model.');
      } else {
        throw new _exceptions.ModelMutateNotSupported('Can\'t check validity for all keys on a non-draftable model.');
      }
    }

    /*
     * To match with the ModelCollection API this uses the same signature and just mutates the single item.
     */

  }, {
    key: 'mutateItem',
    value: function mutateItem(id, mutator) {
      throw new _exceptions.ModelMutateNotSupported('Can\'t mutate a specific ID ' + id + ' on a non-draftable model.');
    }

    /*
     * Get all changes for this item.
     */

  }, {
    key: 'saveItems',
    value: function saveItems(id, keys) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      throw new _exceptions.ModelMutateNotSupported('Can\'t save a specific ID ' + id + ' on a non-draftable model.');
    }
  }, {
    key: 'isReducerBound',
    get: function get() {
      return this._reducer !== undefined;
    }
  }, {
    key: 'boundMeta',
    get: function get() {
      return {
        id: this._storeID,
        reducer: this._reducer,
        dispatch: this._dispatch,
        dataSource: this._dataSource,
        group: this._group,
        filterName: this._filterName
      };
    }
  }, {
    key: 'reactKey',
    get: function get() {
      return this.constructor.modelName + '_' + this._interfaceID;
    }
  }, {
    key: 'saving',
    get: function get() {
      return this._saving;
    }
  }, {
    key: 'saveError',
    get: function get() {
      return this._saveError;
    }
  }, {
    key: 'isItem',
    get: function get() {
      var cls = this.constructor;
      return cls.isItem;
    }
  }, {
    key: 'isCollection',
    get: function get() {
      var cls = this.constructor;
      return cls.isCollection;
    }

    /* Method for formatting new (or changed) data that is to be saved in this model.
     *
     * options may contain:
     *   - reference: Reference proxy for lookup up related data
     */

  }, {
    key: 'draftAction',
    get: function get() {
      if (!this._draftCreation && !this._draftRemoval) {
        return _constants.WRITE_STYLE.UPDATE;
      } else if (this._draftCreation) {
        return _constants.WRITE_STYLE.CREATE;
      } else if (this._draftRemoval) {
        return _constants.WRITE_STYLE.DELETE;
      }
    }

    /*
     * Get the server value for a given key or undefined if there is no server version or
     * the server value matches the draft value.
     */

  }], [{
    key: 'setInsertValues',
    value: function setInsertValues(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reference = options.reference;

      return data;
    }

    /* Method for formatting new (or changed) relationships that will be saved in this model.
     *
     * options may contain:
     *   - reference: Reference proxy for lookup up related data
     */

  }, {
    key: 'setInsertRelationships',
    value: function setInsertRelationships(relationshipData) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reference = options.reference;

      return relationshipData;
    }

    /* Method for formatting the last valid state of the record when the initial server or draft data is not valid.
     *
     * `validation` is the value returned from `validateData`
     * options may contain:
     *   - reference: Reference proxy for lookup up related data
     */

  }, {
    key: 'setInitialValidValues',
    value: function setInitialValidValues(validation) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reference = options.reference;

      return undefined;
    }

    /*
     * Sometimes data needs to be referenced in the schema and then translated into other keys
     * for schema generation/parsing.  This is a common location do that translation.
     *
     * options may contain:
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'formatSchemaOptions',
    value: function formatSchemaOptions(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reference = options.reference;

      return {};
    }

    /*
     * Sometimes data needs to be referenced in the schema and then translated into other keys
     * for schema generation/parsing.  This is a common location do that translation.
     *
     * options may contain:
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'formatRelationshipSchemaOptions',
    value: function formatRelationshipSchemaOptions(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reference = options.reference;

      return {};
    }

    /* Method for formatting new (or changed) data that is to be saved in this model.  In the case of draft updates
     * the current item may also be passed in as a way to reference server variables that could determine the format
     * of the data.
     *
     * options may contain:
     *  - item: Existing combined state for the instance of the model
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'formatData',
    value: function formatData(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var item = options.item,
          reference = options.reference;

      return data;
    }

    /* Method for formatting the data with immutable containers.
     */

  }, {
    key: 'toImmutable',
    value: function toImmutable(data, options) {
      if (!(0, _utils.isMapEmpty)(data)) {
        var schemaOptions = this.formatSchemaOptions(data, options);
        return this.schema.toImmutable(data, schemaOptions);
      } else {
        return new this.schema.Record();
      }
    }

    /* Method for formatting new (or changed) relationships that are to be saved in this model.  In the case of draft
     * updates the current item may also be passed in as a way to reference server variables that could determine the
     * format of the data.
     *
     * options may contain:
     *  - item: Existing combined state for the instance of the model
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'formatRelationships',
    value: function formatRelationships(relationshipData) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var item = options.item,
          reference = options.reference;

      return relationshipData;
    }

    /* Method for formatting the relationships with immutable containers.
     */

  }, {
    key: 'toImmutableRelationships',
    value: function toImmutableRelationships(relationshipData, options) {
      if (!(0, _utils.isMapEmpty)(relationshipData)) {
        var schemaOptions = this.formatRelationshipSchemaOptions(relationshipData, options);
        return this.relationshipSchema.toImmutable(relationshipData, schemaOptions);
      } else {
        return new this.relationshipSchema.Record();
      }
    }

    /*
     * Method for splitting any changes into data and relationship parts
     */

  }, {
    key: 'splitChanges',
    value: function splitChanges(changes) {
      var dataChanges = {},
          relationshipChanges = {};

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _utils.walkMap)(changes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              change = _step2$value[1];

          if (this.schema.keys.has(key)) {
            dataChanges[key] = change;
          } else if (this.relationshipSchema.keys.has(key)) {
            relationshipChanges[key] = change;
          } else {
            throw new Error(key + ' is unknown');
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return [dataChanges, relationshipChanges];
    }

    /*
     * Method for validating data that has come in from an untrusted source (usually the user).  This method does a best
     * effort attempt to format the data according to the schema, but will leave it untouched if it cannot convert it.
     *
     * options may contain:
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'validateData',
    value: function validateData(combined, options) {
      var schemaOptions = this.formatSchemaOptions(combined, options);
      var invalid = this.schema.validateMap(combined, schemaOptions);
      var valid = (0, _immutable.Set)(this.schema.keys.filter(function (k) {
        return !invalid.has(k);
      }));
      return { valid: valid, invalid: invalid, data: combined };
    }

    /*
     * Method for validating data that has come in from an untrusted source (usually the user).  This method does a best
     * effort attempt to format the data according to the schema, but will leave it untouched if it cannot convert it.
     *
     * options may contain:
     *  - reference: Reference proxy for looking up related data
     */

  }, {
    key: 'validateRelationships',
    value: function validateRelationships() {
      var relationships = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
      var options = arguments[1];

      var schemaOptions = this.formatRelationshipSchemaOptions(relationships, options);
      var invalid = this.relationshipSchema.validateMap(relationships, schemaOptions);
      var valid = (0, _immutable.Set)(this.relationshipSchema.keys.filter(function (k) {
        return !invalid.has(k);
      }));
      return { valid: valid, invalid: invalid, relationships: relationships };
    }
  }, {
    key: 'modelName',
    get: function get() {
      throw new _exceptions.ModelNameNotDefinedError('modelName not defined on ' + this);
    }
  }, {
    key: 'schema',
    get: function get() {
      throw new _exceptions.ModelSchemaNotDefinedError('schema not defined on ${this}');
    }
  }, {
    key: 'relationshipSchema',
    get: function get() {
      return DefaultRelationshipSchema;
    }
  }, {
    key: 'allKeys',
    get: function get() {
      // Lazy load set of all keys
      if (this['_allKeys'] === undefined) {
        this._allKeys = this.schema.keys.union(this.relationshipSchema.keys);
      }
      return this._allKeys;
    }
  }, {
    key: 'CollectionClass',
    get: function get() {
      return DefaultModelCollection;
    }
  }, {
    key: 'isItem',
    get: function get() {
      return true;
    }
  }, {
    key: 'isCollection',
    get: function get() {
      return false;
    }
  }]);

  return ModelBase;
}(ModelBaseRecord), (_applyDecoratedDescriptor(_class3.prototype, 'draftAction', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'draftAction'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'serverValue', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'serverValue'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'serverDiffValue', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'serverDiffValue'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasDraftedChanges', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'hasDraftedChanges'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'draftedChanges', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'draftedChanges'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'firstInvalidMeta', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'firstInvalidMeta'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'isValid', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'isValid'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'saveItems', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class3.prototype, 'saveItems'), _class3.prototype)), _class3);
var ModelUngroupedBase = exports.ModelUngroupedBase = (_class4 = function (_ModelBase) {
  _inherits(ModelUngroupedBase, _ModelBase);

  function ModelUngroupedBase() {
    _classCallCheck(this, ModelUngroupedBase);

    return _possibleConstructorReturn(this, (ModelUngroupedBase.__proto__ || Object.getPrototypeOf(ModelUngroupedBase)).apply(this, arguments));
  }

  _createClass(ModelUngroupedBase, [{
    key: 'hasDraftedChanges',
    value: function hasDraftedChanges() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      // Setup options
      if (options === undefined) {
        options = {};
      }
      var _options = options,
          _options$keys = _options.keys,
          keys = _options$keys === undefined ? _constants.SAVE_ALL : _options$keys,
          _options$includeCreat = _options.includeCreated,
          includeCreated = _options$includeCreat === undefined ? false : _options$includeCreat,
          _options$includeRemov = _options.includeRemoved,
          includeRemoved = _options$includeRemov === undefined ? false : _options$includeRemov;


      if (keys === undefined) {
        keys = _constants.SAVE_ALL;
      }

      if (includeCreated === true && this._draftCreation === true) {
        // EARLY EXIT: Created items are being included, so no keys check is necessary.
        return true;
      }

      if (includeRemoved === true && this._draftRemoval === true) {
        // EARLY EXIT: Removed items are being included, so no keys check is necessary.
        return true;
      }

      if (this._draft === undefined && this._draftRelationships === undefined) {
        // EARLY EXIT: No draft and no relationships.
        return false;
      }

      var schemaKeys = this.constructor.allKeys;
      if (keys === _constants.SAVE_ALL) {
        keys = schemaKeys;
      } else {
        keys = (0, _immutable.Set)(keys);

        if (keys.size === 0) {
          throw new _exceptions.ModelKeyFilterEmpty('An array was passed, but no schema keys were given to hasDraftedChanges.');
        }

        var keyDifference = keys.filter(function (k) {
          return !schemaKeys.has(k);
        });
        if (keyDifference.size > 0) {
          throw new _exceptions.ModelKeyFilterInvalid('Invalid schema keys used in hasDraftedChanges: ' + keyDifference);
        }
      }

      var draftValue = void 0,
          serverValue = void 0,
          schema = this.constructor.schema,
          relationshipSchema = this.constructor.relationshipSchema;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = keys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          if (schema.keys.has(key)) {
            if (this._draft !== undefined) {
              draftValue = this._draft.get(key);
            } else {
              draftValue = undefined;
            }
            if (this._server !== undefined) {
              serverValue = this._server.get(key);
            } else {
              serverValue = undefined;
            }
          } else if (relationshipSchema.keys.has(key)) {
            if (this._draftRelationships !== undefined) {
              draftValue = this._draftRelationships.get(key);
            } else {
              draftValue = undefined;
            }
          } else {
            throw new Error('hasDraftedChanges contains the key, "' + key + '", that wasn\'t in the schema or the relationships.');
          }

          if (this.constructor._containsChange(draftValue, serverValue)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return false;
    }

    /*
     * Get all draft changes in this object (excludes undefined entries in the Record)
     */

  }, {
    key: 'draftedChanges',
    value: function draftedChanges() {
      var _this8 = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SAVE_ALL;

      if (this._draft === undefined && this._draftRelationships === undefined) {
        // EARLY EXIT: No draft and no relationships.
        return (0, _immutable.Map)();
      }

      var schemaKeys = this.constructor.allKeys;
      if (keys === _constants.SAVE_ALL) {
        keys = schemaKeys;
      } else {
        // Only let user specify keys that exist in the schema
        keys = keys.filter(function (k) {
          return schemaKeys.has(k);
        });

        // Looking for a specific subset of keys in the model, just iterate through those keys.
        if (keys.length === 0) {
          // EARLY EXIT: No keys?  Empty Map.
          return (0, _immutable.Map)();
        }
      }

      return (0, _immutable.Map)().withMutations(function (map) {
        var draftValue = void 0,
            serverValue = void 0,
            schema = _this8.constructor.schema,
            relationshipSchema = _this8.constructor.relationshipSchema;

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = keys[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var key = _step4.value;

            if (schema.keys.has(key)) {
              if (_this8._draft !== undefined) {
                draftValue = _this8._draft.get(key);
              } else {
                draftValue = undefined;
              }
              if (_this8._server !== undefined) {
                serverValue = _this8._server.get(key);
              } else {
                serverValue = undefined;
              }
            } else if (relationshipSchema.keys.has(key)) {
              if (_this8._draftRelationships !== undefined) {
                draftValue = _this8._draftRelationships.get(key);
              } else {
                draftValue = undefined;
              }
            } else {
              throw new Error('draftedChanges contains the key, "' + key + '", that wasn\'t in the schema or the relationships.');
            }
            if (_this8.constructor._containsChange(draftValue, serverValue)) {
              map.set(key, draftValue);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return map;
      });
    }

    /*
     * Get first invalid error for a given set of keys
     */

  }, {
    key: 'firstInvalidMeta',
    value: function firstInvalidMeta() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (this._invalid === undefined) {
        // EARLY EXIT: No invalid draft items means the draft is likely valid
        return null;
      }

      if (keys === undefined) {
        keys = _constants.SAVE_ALL;
      }

      var schemaKeys = this.constructor.allKeys;
      if (keys !== _constants.SAVE_ALL) {
        keys = (0, _immutable.Set)(keys);

        if (keys.size === 0) {
          throw new _exceptions.ModelKeyFilterEmpty('An array was passed, but no schema keys were given to firstInvalidMeta.');
        }

        var keyDifference = keys.filter(function (k) {
          return !schemaKeys.has(k);
        });
        if (keyDifference.size > 0) {
          throw new _exceptions.ModelKeyFilterInvalid('Invalid schema keys used in firstInvalidMeta: ' + keyDifference);
        }
      } else {
        keys = schemaKeys;
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = keys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var key = _step5.value;

          var invalidMeta = this._invalid.get(key);
          if (invalidMeta !== undefined && invalidMeta !== null) {
            if (_immutable.List.isList(invalidMeta) && invalidMeta.size !== 0 || !_immutable.List.isList(invalidMeta)) {
              return invalidMeta;
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return null;
    }

    /*
     * Return true if the model is valid.  Optionally filter by the given set of keys.
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      var meta = void 0;
      if (keys !== undefined) {
        meta = this.firstInvalidMeta(keys);
      } else {
        // Don't pass defaults through the call chain
        meta = this.firstInvalidMeta();
      }
      return meta === null;
    }

    /*
     * To match with the ModelCollection API this uses the same signature and just mutates the single item.
     */

  }, {
    key: 'mutateItem',
    value: function mutateItem(id, mutator) {
      if (id !== _constants.STANDALONE_ITEM) {
        throw new _exceptions.ModelMutateIsNotStandaloneError('Can\'t mutate a specific ID ' + id + ' on a non-collection model.');
      }
      return this.withMutations(mutator);
    }

    /*
     * Get all changes for this item.
     */

  }, {
    key: 'saveItems',
    value: function saveItems(id, keys) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (id !== _constants.STANDALONE_ITEM) {
        throw new _exceptions.ModelMutateIsNotStandaloneError('Can\'t get changes for specific ID ' + id + ' on a non-collection model.');
      }

      if (this._saving === true) {
        // EARLY EXIT: Don't return items if a save is in progress.
        return (0, _immutable.List)();
      }

      var changes = this.draftedChanges(keys);
      if (changes.isEmpty()) {
        return (0, _immutable.List)();
      }

      return (0, _immutable.List)([new ApiSave({
        id: _constants.STANDALONE_ITEM,
        api_id: null,
        action: _constants.WRITE_STYLE.UPDATE,
        changes: changes
      })]);
    }
  }, {
    key: 'isGrouped',
    get: function get() {
      var cls = this.constructor;
      return cls.isGrouped;
    }
  }, {
    key: 'uniqueKey',
    get: function get() {
      var cls = this.constructor;
      var uniqueKeyName = cls.uniqueKey;
      return this._combined.get(uniqueKeyName);
    }
  }], [{
    key: 'getUniqueKey',
    value: function getUniqueKey(dataItem) {
      return dataItem[this.uniqueKey];
    }

    /*
     * Helper function recursively determine if a value has a change.
     */

  }, {
    key: '_containsChange',
    value: function _containsChange(value, serverValue) {
      var _this9 = this;

      var _inner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && (typeof serverValue === 'undefined' ? 'undefined' : _typeof(serverValue)) === 'object') {
        if (_immutable.List.isList(value)) {
          if (_immutable.List.isList(serverValue) && value.size === serverValue.size) {
            return value.some(function (v, i) {
              return _this9._containsChange(v, serverValue.get(i), true);
            });
          } else {
            return true;
          }
        } else {
          // Handles Record, Map, and object
          if (_immutable.Map.isMap(value)) {
            if (_immutable.Map.isMap(serverValue) && value.size === serverValue.size) {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = (0, _utils.walkMap)(value)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var _step6$value = _slicedToArray(_step6.value, 2),
                      k = _step6$value[0],
                      v = _step6$value[1];

                  if (this._containsChange(v, serverValue.get(k), true)) {
                    return true;
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }

              return false;
            }
            return true;
          } else {
            if (value == void 0 || serverValue == void 0) {
              return value !== serverValue;
            } else if (Object.keys(value).length === Object.keys(serverValue).length) {
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = (0, _utils.walkMap)(value)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var _step7$value = _slicedToArray(_step7.value, 2),
                      k = _step7$value[0],
                      v = _step7$value[1];

                  if (this._containsChange(v, serverValue[k], true)) {
                    return true;
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }

              return false;
            }
            return true;
          }
        }
      } else if (Array.isArray(value)) {
        if (Array.isArray(serverValue) && value.length === serverValue.length) {
          return value.some(function (v, i) {
            return _this9._containsChange(v, serverValue[i], true);
          });
        } else {
          return false;
        }
      }

      if (_inner) {
        return value !== serverValue || value !== undefined && value !== null;
      } else {
        return value !== serverValue && value !== undefined;
      }
    }

    /*
     * Check if this item has any drafted changes (optionally including if this is a removed or created item)
     */

  }, {
    key: 'uniqueKey',
    get: function get() {
      throw new _exceptions.ModelUniqueKeyNotDefinedError('uniqueKey not defined on ' + this);
    }
  }, {
    key: 'isGrouped',
    get: function get() {
      return false;
    }
  }, {
    key: 'useOnly',
    get: function get() {
      return false;
    }
  }]);

  return ModelUngroupedBase;
}(ModelBase), (_applyDecoratedDescriptor(_class4.prototype, 'hasDraftedChanges', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class4.prototype, 'hasDraftedChanges'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'draftedChanges', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class4.prototype, 'draftedChanges'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'firstInvalidMeta', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class4.prototype, 'firstInvalidMeta'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'isValid', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class4.prototype, 'isValid'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'saveItems', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class4.prototype, 'saveItems'), _class4.prototype)), _class4);
var ModelGroupedBase = exports.ModelGroupedBase = (_class5 = function (_ModelBase2) {
  _inherits(ModelGroupedBase, _ModelBase2);

  function ModelGroupedBase() {
    _classCallCheck(this, ModelGroupedBase);

    return _possibleConstructorReturn(this, (ModelGroupedBase.__proto__ || Object.getPrototypeOf(ModelGroupedBase)).apply(this, arguments));
  }

  _createClass(ModelGroupedBase, [{
    key: 'isGrouped',


    /*
     * Helper for getting the static grouped model status on the instance
     */
    get: function get() {
      var cls = this.constructor;
      return cls.isGrouped;
    }

    /*
     * Return the group key separater that will be used to generate a unique key based on the group keys
     */

  }, {
    key: 'groupKeys',


    /*
     * Helper for getting the static group keys on the instance.
     */
    get: function get() {
      var cls = this.constructor;
      return cls.groupKeys;
    }

    /*
     * Get the unique key for model instance
     */

  }, {
    key: 'uniqueKey',
    get: function get() {
      var cls = this.constructor;
      return cls.generateGroupKey(this._server);
    }

    /*
     * Generate a unique key given a raw data item
     */

  }], [{
    key: 'generateGroupKey',


    /*
     * Genarate a group key for a given raw data item.
     */
    value: function generateGroupKey(item) {
      if (this.groupKeys.length === 1) {
        return item[this.groupKeys[0]]; // make sure to NOT join to preserve type if there's only one key!
      } else {
        return this.groupKeys.map(function (groupKey) {
          return item[groupKey];
        }).join(this.groupKeySeparator);
      }
    }

    /*
     * Record of all groups keys
     */

  }, {
    key: 'getUniqueKey',
    value: function getUniqueKey(dataItem) {
      return this.generateGroupKey(dataItem);
    }
  }, {
    key: 'isGrouped',


    /*
     * Mark this as a grouped model
     */
    get: function get() {
      return true;
    }
  }, {
    key: 'groupKeySeparator',
    get: function get() {
      return "-";
    }
  }, {
    key: 'groupKeys',
    get: function get() {
      throw new _exceptions.ModelGroupKeysNotDefinedError('groupKeys not defined on ' + this);
    }
  }]);

  return ModelGroupedBase;
}(ModelBase), (_applyDecoratedDescriptor(_class5.prototype, 'uniqueKey', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class5.prototype, 'uniqueKey'), _class5.prototype)), _class5);